import { jsx, jsxs } from 'react/jsx-runtime';
import { Component } from 'react';
import UnexpectedErrorPage from '../ErrorPages/UnexpectedErrorPage.js';
import { isProduction } from '../Utils/environment.js';

/**
Isola eventuali eccezioni javascript evitando al visualizzazione di una pagina bianca, mostrando un messaggio di errore user-friendly.
Integrato di default all'interno del componente Sidebar.Body.
 */
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        // api pubblica
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.resetErrors = () => {
            this.setState({
                error: null,
                errorInfo: null,
            });
        };
        this.state = {
            error: null,
            errorInfo: null,
            showDetails: !isProduction(),
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { toggleShow } = this.props;
        if (nextProps.toggleShow !== toggleShow) {
            this.setState({
                error: null,
                errorInfo: null,
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { onCatch } = this.props;
        this.setState({
            error,
            errorInfo,
        }, () => {
            if (typeof onCatch === 'function') {
                onCatch(error, errorInfo);
            }
        });
    }
    render() {
        const { children, errorTitle } = this.props;
        const { error, errorInfo, showDetails } = this.state;
        if (errorInfo && !errorTitle)
            return jsx(UnexpectedErrorPage, {});
        return errorInfo
            ? (jsx("div", { className: "errorBoundary", children: jsxs("div", { className: "errorBoundary__content", children: [errorTitle, showDetails && (jsxs("details", { className: "errorDetails", children: [error && error.toString(), jsx("br", {}), errorInfo.componentStack] }))] }) })) : children;
    }
}
ErrorBoundary.defaultProps = {
    errorTitle: null,
    onCatch: null,
    toggleShow: false,
};

export { ErrorBoundary as default };
